import { useRef } from "react";
import { FiInfo } from "react-icons/fi"
import ReactTooltip from "react-tooltip"

interface InfoIconProps {
	size?: number;
	tooltipText: string;
}

/**
 * Displays an info icon with a tooltip
 * @param param0 
 * @returns 
 */
export const InfoTooltip: React.FC<InfoIconProps> = ({ size = 16, tooltipText }) => {
	const idRef = useRef<string>(crypto.randomUUID());
	return <>
		<FiInfo
			className="cursor- ml-1"
			size={size}
			data-tip
			data-for={idRef.current}
		/>
		<ReactTooltip
			id={idRef.current}
			place="right"
			effect="solid"
			className="!border !border-gray-400 !rounded !text-xs !normal-case !px-2 !py-1 !font-normal !max-w-md"
			arrowColor="transparent"
		>
			{tooltipText}
		</ReactTooltip>
	</>
}